import React from 'react'
import Navbar from '../Navbar/Navbar'
import HeroSection from '../HeroSection/HeroSection'
import Services from '../Services/Services'
import About from '../About/About'
import Techniques from '../Techniques/Techniques'
import Footer from '../Footer/Footer'
import Contact from '../Contact/Contact'

function HomePage() {
  return (
    <div>
        <Navbar/>
        <HeroSection/>
        <Services/>
        <About/>
        <Techniques/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default HomePage